import { FaLaptopCode, FaShieldAlt, FaBullhorn, FaCloud, FaArrowRight } from 'react-icons/fa';
import { motion } from 'framer-motion';

const CoreFeatures = () => {
    const features = [
        {
            icon: FaLaptopCode,
            title: 'IT Consultation',
            description: 'Podcasting Optonal Change Management Inside Of Workflows To Establish A Framework.',
            color: 'from-[#106bcb] to-[#22446b]',
            delay: 0
        },
        {
            icon: FaShieldAlt,
            title: 'Data Security',
            description: 'Leverage Agile Frameworks To Provide A Robust Synopsis For High Level Overviews.',
            color: 'from-[#22446b] to-[#106bcb]',
            delay: 0.1
        },
        {
            icon: FaBullhorn,
            title: 'Digital Marketing',
            description: 'Capitalize On Low Hanging Fruit Identify A Ballpark Added Value Activity To Beta Test.',
            color: 'from-[#106bcb] to-[#22446b]',
            delay: 0.2
        },
        {
            icon: FaCloud,
            title: 'Cloud Services',
            description: 'Bring To The Table Win-win Survival Strategies To Ensure Proactive Domination.',
            color: 'from-[#22446b] to-[#106bcb]',
            delay: 0.3
        }
    ];

    return (
        <div className="relative z-30 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto mt-0 sm:mt-16 lg:mt-20 mb-12 sm:mb-16 lg:mb-20 font-opensans">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                {features.map((feature, index) => (
                    <motion.div
                        key={index}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true }}
                        transition={{ delay: feature.delay, duration: 0.5 }}
                        className="bg-white rounded-xl shadow-xl p-8 border-b-4 border-transparent hover:border-[#106bcb] transition-all duration-300 group hover:-translate-y-2 card-hover"
                    >
                        <div className={`w-16 h-16 rounded-full bg-gradient-to-r ${feature.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 shadow-md`}>
                            <feature.icon className="text-white text-2xl" />
                        </div>
                        <h3 className="text-xl font-rajdhani font-bold text-[#22446b] mb-3 group-hover:text-[#106bcb] transition-colors">
                            {feature.title}
                        </h3>
                        <p className="text-gray-600 text-sm leading-relaxed mb-4">
                            {feature.description}
                        </p>
                        
                        {/* <div className="flex items-center text-[#106bcb] font-bold text-sm opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300">
                            <span>Read More</span>
                            <FaArrowRight className="ml-2 text-xs" />
                        </div> */}
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default CoreFeatures;
